import React from 'react';
import Text from '../../elements/Text';
import Button from '../../elements/Button';
import { StyledProps } from '@front10';
import { TextProps } from '../../elements/Text/Text';

interface Props {
  value: number;
  onAction: () => void;
  label?: string;
  valueSettings?: Partial<TextProps>;
  labelSettings?: Partial<TextProps>;
  suffixValue?: string;
  prefixValue?: string;
}
const defaultProps = {
  prefixValue: '',
  suffixValue: '',
};

export type BudgetCardProps = StyledProps<Props> & typeof defaultProps;

export default function BudgetCard({
  value,
  onAction,
  label = 'or less',
  valueSettings,
  labelSettings,
  suffixValue,
  prefixValue,
  ...props
}: BudgetCardProps) {
  return (
    <Button
      style={{ minWidth: 120, minHeight: 120 }}
      display="flex"
      margin="1"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      borderColor="primary"
      bgColor="transparent"
      onClick={onAction}
      {...props}
    >
      <Text fontSize="8" textColor="primary" {...valueSettings}>
        {prefixValue}
        {value}
        {suffixValue}
      </Text>
      {label && (
        <Text fontSize="3" textTransform="uppercase" {...labelSettings}>
          {label}
        </Text>
      )}
    </Button>
  );
}

BudgetCard.defaultProps = defaultProps;
